var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29 8v16H3V8h26m0-1H3a1 1 0 00-1 1v16a1 1 0 001 1h26a1 1 0 001-1V8a1 1 0 00-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.886 13.858a16.111 16.111 0 00-2.022-.9l-.027-.01-.555.562.07.023a15.374 15.374 0 011.772.737l-.785.788a13.744 13.744 0 00-5.405-1.096h-.082l-.038.001a8.436 8.436 0 00-3.66-1.591 15.928 15.928 0 015.833-.323 15.917 15.917 0 01.616.092.366.366 0 01-.008-.073.357.357 0 01.32-.357.308.308 0 01.04-.003.294.294 0 01.098.017.36.36 0 01.192.54 15.666 15.666 0 011.768.485l.534-.555a29.61 29.61 0 01-.198-.084l-.028-.011a16.507 16.507 0 00-1.412-.416 1.001 1.001 0 00-1.723-.33 16.719 16.719 0 00-2.252-.153 16.51 16.51 0 00-5.237.849l-.031.01v.904h.045a7.727 7.727 0 013.907 1.06 13.739 13.739 0 00-3.924.966l-.028.01v.723h.045a5.137 5.137 0 015.1 5.163v.046h.706v-.046a5.935 5.935 0 00-1.272-3.668 5.84 5.84 0 00-3.028-2.01 13.1 13.1 0 013.354-.528 7.923 7.923 0 012.966 6.206v.046h.706v-.046a8.637 8.637 0 00-2.499-6.109 8.033 8.033 0 00-.082-.082 13.028 13.028 0 014.614 1.112l.22.098 1.36-1.363.462-.458z",
  fillRule: "evenodd"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--ticket-brakar-outline-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TicketBrakarOutlineIcon';
export default Icon;